import XFlag from './XFlag.vue'

export default XFlag



// WEBPACK FOOTER //
// ./src/app/components/common/xFlag/index.js